import { AfterViewInit, Component, HostListener, Input, OnInit } from '@angular/core';
import { UiHelper } from '@helpers/ui.helper';
// for material slide component etc.

import { LocalizationService } from '@services/localization.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'match-slider',
  templateUrl: '../sharedTemplates/match.slider.component.html',
})
export class MatchSliderComponent implements OnInit {
  windowsWidth = window.innerWidth;
  positionPX = 0;

  listArray = [];
  listArraySize = 0;
  selectedListItem = 1;

  @Input()
  countRow = 2;
  @Input()
  isLive = false;

  @Input()
  slideShowTime = 2;

  @Input()
  set slideShow(e) {
    if (e) {
      this.slideShowSetter();
    }
  }

  @Input()
  set data(e) {
    this.listArray = e;
    ////console.log("---------e------------",e);
    /*
    e.forEach((x) => {

      const _data = {
        'imageUrl': x.FileName,
        'captions': x.Title
      };

      this.listArray.push(_data);
    });
    */
    if (this.listArray != undefined) this.listArraySize = this.listArray.length;
  }

  constructor(private _UiHelper: UiHelper, public _LZ: LocalizationService, public _Router: Router, private _ActivatedRoute: ActivatedRoute) {}

  onSwipeLeft(e) {
    ////console.log('left');
    if (this.selectedListItem != this.listArraySize) {
      this.positionPX += -this.windowsWidth / this.countRow;
      this.selectedListItem++;
    }
  }

  onSwipeRight(e) {
    ////console.log('right');
    if (this.selectedListItem != 1) {
      this.positionPX += this.windowsWidth / this.countRow;
      this.selectedListItem--;
    }
  }

  changeSlider(v) {
    this.positionPX = (-(v - 1) * this.windowsWidth) / this.countRow;
    this.selectedListItem = v;
  }

  slideShowSetter() {
    setInterval(() => {
      if (this.selectedListItem != this.listArraySize) {
        this.changeSlider(this.selectedListItem + 1);
      } else {
        this.changeSlider(1);
      }
    }, this.slideShowTime * 1000);
  }

  transformDateObj(v) {
    return new Date(v);
  }

  ngOnInit() {
    if (this.windowsWidth === 0) {
      this.windowsWidth = this._UiHelper.windowsWidth;
    }
    this._UiHelper.windowResized.subscribe(x => {
      this.windowsWidth = x.w;
      this.positionPX = (-(this.selectedListItem - 1) * this.windowsWidth) / this.countRow;
    });
  }
  goEventDetail(e) {
    this._Router.navigate(['/eventdetail', e]);
  }
  goLiveEventDetail(e) {
    this._Router.navigate(['/liveeventdetail', e]);
  }
  splitGroupName(e) {
    if (e.includes('|')) return e.split('|')[1];
    else return e;
  }
}
